<template>
	<div v-if="raw">
		<div
			v-if="raw.data"
			is="app-content-element"
			v-for="(item,index) in raw.data.attributes.content"
			:key="index"
			:type="item.type"
			:objectdata="item"
		>{{index}}</div>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	import AppContentElement from "./AppContentElement";
	export default {
		extends: Base,
		components: {
			AppContentElement
		},
		data() {
			return {
				vueroutename: this.$route.params.current,
				apicomponentname: "contents"
			};
		},
		updated() {
			// add back-button to content page after first content-element
			let objElems = this.$children;
			// get forst child element
			if (objElems) {
			let firstChildElem = objElems[0].$el;
			this.appendBackButton(firstChildElem);
			}
		},
		mounted() {},
		created() {
			this.init();
		},
		methods: {
			appendBackButton(el) {
				// append back-button to contentPage sites
				let elementToAppend = el;
				let elBackButton = "";
				let addBackBtn = true;
				let siteBackBtn = document.querySelector(".site-back-btn");
				// disable back-button for campaign-sites or is startseite or button already exists
				if (
					(this.raw.data && this.raw.data.attributes.isCampaingsite) ||
					this.$route.params.current == "startseite" ||
					(typeof siteBackBtn != "undefined" && siteBackBtn != null)
				) {
					addBackBtn = false;
				}
				if (addBackBtn) {
					elBackButton = document.createElement("div");
					elBackButton.classList.add("screen-wrapper");
					elBackButton.innerHTML =
						'<div class="site-back-btn"><a onclick="history.back()" class="btn-go-back">Zurück</a><span><span></span><span></span></span></div>';
					elementToAppend.parentNode.insertBefore(
						elBackButton,
						elementToAppend.nextSibling
					);
					// elementToAppend.appendChild(elBackButton);
				}
			}
		},

		watch: {
			$route(to, from) {
				this.objectdata = {};
				// this.raw = {};
				this.init();
			}
		}
	};
</script>

<style lang="scss">
</style>